import io from 'socket.io-client';
import mockData from './mock-data-push-api';
import { getPushAPI } from '../../config/kambi/api-config/kambi-config';
import Global from '../../global';

const SocketClient = (function() {
  let instance;

  function init(options) {
    let socket = null;
    const {
      ioMock,
      onConnect,
      onDisconnect,
      onReconnect,
      onError,
      onReconnectAttempt,
      onMessage,
      useProdApis
    } = options;
    if (ioMock) {
      socket = new options.ioMock(mockData.sockUrl);
    } else {
      socket = io(getPushAPI(useProdApis), {
        transports: ['websocket'],
        path: '/socket.io',
        reconnectionAttempts: 100
      });
    }

    socket.on(
      'connect',
      onConnect
        ? onConnect
        : () => {
            Global.logger.debug('[DEFAULT] Socket connected');
          }
    );
    socket.on(
      'disconnect',
      onDisconnect
        ? onDisconnect
        : reason => {
            Global.logger.debug('[DEFAULT] socket disconnected ' + reason);
          }
    );
    socket.on(
      'reconnect',
      onReconnect
        ? onReconnect
        : attemptNo => {
            Global.logger.debug('[DEFAULT] socket reconnected ' + attemptNo);
          }
    );
    socket.on(
      'error',
      onError
        ? onError
        : err => {
            Global.logger.debug('[DEFAULT] socket error ' + err);
          }
    );
    socket.on(
      'reconnect_attempt',
      onReconnectAttempt
        ? onReconnectAttempt
        : no => {
            Global.logger.debug('[DEFAULT] Socket reconnect attempt ' + no);
          }
    );
    socket.on(
      'message',
      onMessage
        ? onMessage
        : msg => {
            Global.logger.debug('[DEFAULT] Message received ' + msg);
          }
    );

    return {
      disconnect: function() {
        if (socket.connected) socket.close();
      },
      openSocket: function() {
        socket.open();
      },
      subscribeToTopics: function(topics) {
        topics.map(topic => {
          socket.emit('subscribe', { topic });
        });
      },
      unsubscribeFromTopic: function(topic) {
        socket.emit('unsubscribe', { topic });
      }
    };
  }

  return {
    getInstance: function(options) {
      if (!instance) {
        instance = init(options);
      }
      return instance;
    },
    destroy: function() {
      instance = null;
    }
  };
})();

export default SocketClient;
